import Cookies from 'js-cookie';

export function validMail(email) {
    const regex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regex.test(email);
}
export function validEmpty(value) {
    //true if not empty
    let valid = false;
    if (Array.isArray(value)) {
        valid = value.length === 0 ? false : true;
    } else if (typeof value === "string") {
        valid = !(value.replaceAll(" ", "") === "" || value === null);
    } else if (typeof value === "number") {
        if (value) valid = true;
    }
    return valid;
}
export function validPassword(str) {
    //at least 8 letter, 1 symbol, 1 number, 1lower and upper case letter
    var re = /^(?=.*\d)(?=.*[!@#$%^&*?+-=])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return re.test(str);
}
export async function validVat(vat) {
    if (vat.length < 4 | vat.length > 14) {
        return false
    }
    const country_code = vat.slice(0, 2)
    const number = vat.slice(2)
    const params = {
        country: country_code,
        vat: number
    };

    // créer l'URL complète en une seule ligne
    const url = `${process.env.REACT_APP_API_URL}check_vat?${new URLSearchParams(params)}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Token " + Cookies.get('jwtuser')
            }
        }); // Attente de la réponse de l'API

        if (response.ok) { // Vérification du statut de la réponse (200-299)
            const data = await response.json();
            if(data.hasOwnProperty("valid")){
                return data.valid
            } else{
                return false
            }
        }
    } catch {
        return true
    }

    return true
}
export function validOrderNr(value) {
    let valid = true;

    if (value.length !== 12) {
        valid = false;
    } else if (value.charAt(0) !== "5") {
        valid = false;
    } else if (value.slice(0, 3) === "525") {
        const number = "00" + value.slice(0, -2)
        const correctCheckDigit = parseInt(value.slice(-2, -1), 10)

        const evenSum = number.split('').map(Number).filter((_, index) => index % 2 === 1).reduce((sum, num) => sum + num, 0);
        const oddSum = number.split('').map(Number).filter((_, index) => index % 2 === 0).reduce((sum, num) => sum + num, 0);

        const remainder = (evenSum * 3 + oddSum) % 10;
        const checkDigit = remainder === 0 ? 0 : (10 - remainder)
        if (checkDigit !== correctCheckDigit) valid = false;
    }
    //exactly 12 characters
    return valid;
}
export function validPhone(value = "") {
    const regex = /[^0-9.\-/\s+]/;
    if (regex.test(value)) {
        return false
    }
    const phone = value.replace(/\D/g, '')
    return phone.length > 7
}
export function hasGeneticAnalyse(analyses) {

    let has_genetic_analyse = false
    analyses.forEach((category) => {
        if (category.code === "GENETIQUE") {
            category.bilans.forEach((falseBilan) => {
                if (falseBilan?.checked) {
                    has_genetic_analyse = true
                }
            })
            category.analyses.forEach((analyse) => {
                if (analyse?.checked) {
                    has_genetic_analyse = true
                }
            })
        }
    })

    return has_genetic_analyse
}